<app-page-header subtitle="Behoefte">
    <div class="performer-selector flex-row d-flex" filters>
        <app-filter-menu
            label="Soort planning"
            tooltip="Filter op soort planning"
            [options]="entityTypeOptions"
            [control]="fcFilteredEntityTypes" />

        <app-filter-menu
            label="Materiaaltype"
            tooltip="Filter op materiaaltype"
            [options]="materialTypeOptions"
            [control]="fcFilteredMaterialTypes" />

        <app-filter-menu
            label="Strepen / figuratie"
            tooltip="Filter op strepen/figuratie"
            [options]="markingKindOptions"
            [control]="fcFilteredMarkingKind" />

        <mat-form-field class="search" appearance="fill" subscriptSizing="dynamic">
            <input
                [formControl]="fcSearchNeed"
                (keydown.escape)="fcSearchNeed.setValue('')"
                matInput
                placeholder="Zoek behoefte" />

            @if (fcSearchNeed.value) {
                <button (click)="fcSearchNeed.setValue('')" matSuffix type="button" mat-icon-button aria-label="Clear">
                    <i class="fas fa-times"></i>
                </button>
            }
        </mat-form-field>
    </div>
</app-page-header>

<div class="behoefte-overview">
    <div class="columns">
        @for (column of columns; track column.key) {
            <div class="column">
                <div class="column-header">
                    <span class="label">{{ column.label }}</span>
                    <span class="count">{{ column.needs.length }}</span>
                </div>

                <div class="column-items">
                    @for (need of column.needs; track need.id) {
                        <app-need-item
                            [need]="need"
                            [readOnly]="true"
                            [materialsById]="materialsById"
                            [contextMenu]="needContextMenu"
                            (open)="openPlanning($event)"
                            (hoverChange)="hoveredNeedId = $event" />
                    }
                </div>
            </div>
        }
    </div>

    <div class="map-container border-top border-dark">
        <app-planning-map
            #planningMap
            [plannings]="filteredNeeds"
            [hoverPlanningId]="hoveredNeedId ?? highlightService.hoveredPlanningId"
            (planningClick)="openPlanning($event)"
            (mapFilterChange)="onMapFilterChange($event)"
            (planningHover)="onPlanningHover($event)" />
    </div>
</div>

<ng-template #needContextMenu let-need="need">
    <div class="context-menu" cdkMenu>
        <button class="menu-item" (click)="planningMap.focus(need.id)" cdkMenuItem>
            <i class="fa-regular fa-map"></i> Toon op kaart
        </button>
    </div>
</ng-template>
